import React from "react";
import { UserAuth } from "app/context/AuthContext";
import { AsButton } from "app/subframe";
import { AlertTriangle } from "lucide-react";

export const ImpersonationBanner: React.FC = () => {
  const { user, revert } = UserAuth();

  if (!user?.isImpersonating) return null;

  return (
    <div className="bg-amber-100 border-b border-amber-200 px-4 py-2 flex items-center justify-between shadow-sm animate-in fade-in slide-in-from-top duration-500">
      <div className="flex items-center gap-3 text-amber-900">
        <AlertTriangle className="w-5 h-5 text-amber-600 animate-pulse" />
        <span className="text-sm font-medium">
          You are currently logged in as <span className="font-bold underline">{user?.name}</span> ({user?.email})
        </span>
      </div>
      <AsButton
        variant="secondary"
        size="sm"
        className="bg-amber-600 hover:bg-amber-700 text-white border-none shadow-md"
        onClick={revert}
        leadingIcon="FeatherHome"
        text="Go Back to My Account"
      />
    </div>
  );
};
